import React, { useCallback, useLayoutEffect, useState } from 'react';
import {
  Modal,
  View,
  Text,
  TouchableOpacity,
  TouchableWithoutFeedback,
  StyleSheet,
  Platform,
} from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { GUEST_READ_ONLY_MESSAGE, GUEST_READ_ONLY_TITLE } from '../utils/guestReadOnlyCopy';
import { registerGuestPromptListener, type GuestPromptLogout } from '../utils/guestPromptBridge';

/**
 * Misafir uyarısı: react-native-web'de Alert.alert güvenilir değil; tüm platformlarda Modal kullanılır.
 */
export function GuestPromptModalHost() {
  const insets = useSafeAreaInsets();
  const [visible, setVisible] = useState(false);
  const [logoutRef, setLogoutRef] = useState<GuestPromptLogout | null>(null);

  useLayoutEffect(() => {
    return registerGuestPromptListener(payload => {
      if (!payload) {
        setVisible(false);
        setLogoutRef(null);
        return;
      }
      setLogoutRef(() => payload.logout);
      setVisible(true);
    });
  }, []);

  const onDismiss = useCallback(() => {
    setVisible(false);
    setLogoutRef(null);
  }, []);

  const onRegister = useCallback(async () => {
    const fn = logoutRef;
    setVisible(false);
    setLogoutRef(null);
    if (fn) {
      await Promise.resolve(fn());
    }
  }, [logoutRef]);

  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onDismiss}
      presentationStyle="overFullScreen">
 <View className="flex-1 justify-center px-5">
        <TouchableWithoutFeedback onPress={onDismiss} accessibilityRole="button">
          <View style={[StyleSheet.absoluteFillObject, { backgroundColor: 'rgba(0,0,0,0.45)' }]} />
        </TouchableWithoutFeedback>
        <View
          className="rounded-3xl border border-zinc-200 bg-white p-7 dark:border-zinc-800 dark:bg-zinc-900"
          style={{
            zIndex: 1,
            marginBottom: Math.max(insets.bottom, 12),
            ...(Platform.OS === 'web'
              ? { maxWidth: 400, width: '100%', alignSelf: 'center' as const }
              : null),
          }}>
          <Text className="text-lg font-bold text-zinc-900 dark:text-zinc-50">{GUEST_READ_ONLY_TITLE}</Text>
          <Text className="mt-4 text-sm leading-6 text-zinc-600 dark:text-zinc-400">
            {GUEST_READ_ONLY_MESSAGE}
          </Text>
          <View className="mt-8 flex-row gap-3">
            <TouchableOpacity
              activeOpacity={0.88}
              onPress={onDismiss}
              className="flex-1 rounded-2xl border border-zinc-200 bg-white py-3.5 dark:border-zinc-700 dark:bg-zinc-800">
              <Text className="text-center text-base font-semibold text-zinc-700 dark:text-zinc-200">
                Tamam
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              activeOpacity={0.88}
              onPress={() => void onRegister()}
              className="flex-1 rounded-2xl border border-zinc-900 bg-zinc-900 py-3.5 dark:border-zinc-50 dark:bg-zinc-50">
              <Text className="text-center text-base font-semibold text-white dark:text-zinc-950">
                Kayıt Ol
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
}
